var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 0C3.2917 0 0.600098 2.6916 0.600098 6C0.600098 9.3084 3.2917 12 6.6001 12C9.9085 12 12.6001 9.3084 12.6001 6C12.6001 2.6916 9.9085 0 6.6001 0ZM6.6001 10.8C3.9535 10.8 1.8001 8.6466 1.8001 6C1.8001 3.3534 3.9535 1.2 6.6001 1.2C9.2467 1.2 11.4001 3.3534 11.4001 6C11.4001 8.6466 9.2467 10.8 6.6001 10.8Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20024 3H6.00024V6.2484L7.97604 8.2242L8.82444 7.3758L7.20024 5.7516V3Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.8d422a0f9dc099edc8701fba3c7c8ed0.svg";
export { ForwardRef as ReactComponent };